import React, { useEffect, useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/master/access/Datatables";
import DataMenu from "component/master/access/DataMenu";

function Access() {
  const [users, setUsers] = useState([]);
  const [menus, setMenus] = useState([]);
  const [access, setAccess] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);


  const fetchData = async (endpoint, setter, sortBy = null, method = "GET", body = null) => {
    const token = localStorage.getItem("token");
    try {
      const options = {
        method,
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };

      // kalau POST, sertakan body
      if (method === "POST" && body) {
        options.body = JSON.stringify(body);
      }

      const response = await fetch(
        `${process.env.REACT_APP_API}/${endpoint}`,
        options
      );

      if (!response.ok) throw new Error(`Gagal mengambil data ${endpoint}`);

      const data = await response.json();
      let result = data.data;

      // kalau perlu diurutkan
      if (sortBy) {
        result = [...result].sort((a, b) => a[sortBy] - b[sortBy]);
      }

      setter(result);
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Access";
      window.scrollTo(0, 0);
      fetchData("user", setUsers);
      fetchData("menu", setMenus, "menu_id");
  }, []);

  const handleAddAccess = async (user_id, entry_by, selectedMenus) => {
    if (!user_id || selectedMenus.length === 0) {
      showError("Pilih user dan minimal satu menu untuk ditambahkan!");
      return;
    }

    const confirmed = await showConfirm({
      title: "Tambah Akses",
      text: `Apakah Anda yakin ingin menambah akses untuk ${selectedMenus.length} menu ke user ${user_id}?`,
      confirmButtonText: "Tambah",
    });

    if (!confirmed) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API}/access/add`,
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id,
            menus: selectedMenus.map((m) => ({
              menu_id: m.menu_id,
              ins: "N",
              upd: "N",
              del: "N",
              sav: "N",
              rpt: "N",
              qry: "N",
            })),
            entry_by: entry_by,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        if (result.msg_code === "201") {
          showError(result.msg_desc || "Beberapa menu sudah ada untuk user ini");
        } else {
          showSuccess(result.msg_desc || "Access berhasil ditambahkan");
        }
        await fetchData("access", setAccess, null, "POST", { username: user_id });
      } else {
        showError(result.msg_desc || "Gagal menambahkan access");
      }
    } catch (error) {
      console.error("Error addAccess:", error);
      showError(error.response?.data?.msg_desc || "Terjadi kesalahan saat menambah access");
    }
  };

  const handleDeleteAccess = async (access) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Access',
        text: `Apakah Anda yakin ingin menghapus akses untuk menu "${access.menu_desc}" milik user "${access.user_id}"?`,
        confirmButtonText: 'Hapus'
      });

      if (!confirmed) return;

      const token = localStorage.getItem("token");

      const response = await fetch(
        `${process.env.REACT_APP_API}/access`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: access.user_id,
            menu_id: access.menu_id,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        showSuccess(result.message || "Access berhasil dihapus");
        if (selectedUser) {
          fetchData("access", setAccess, null, "POST", { username: selectedUser });
        }
      } else {
        showError(result.message || "Gagal menghapus access");
      }

    } catch (error) {
      console.error("Error deleting access:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus access");
    }
  };

  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Access Management</h5>
                            </div>
                            <div class="row mt-3">
                              <div class="col-lg-4">
                                <DataMenu
                                  users={users}
                                  menus={menus}
                                  onSelectUser={(selected) => {
                                    if (selected?.username && !selected.selectedMenus) {
                                      // 🟢 Case 1: User dipilih dari LOV User → Fetch aksesnya
                                      setSelectedUser(selected.username);
                                      fetchData("access", setAccess, null, "POST", { username: selected.username });
                                    } else {
                                      setAccess([]);
                                    }
                                  }}
                                  onSaveAccess={({ username, entry_by, selectedMenus }) =>
                                    handleAddAccess(username, entry_by, selectedMenus)
                                  }
                                  onSaveAll={({ username, entry_by, selectedMenus }) =>
                                    handleAddAccess(username, entry_by, selectedMenus)
                                  }
                                />
                              </div>
                              <div class="col-lg-8">
                                <Datatables data={access} onDeleteAccess={handleDeleteAccess}/>
                              </div>
                            </div>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-access-toggle"></div>
    </div>
  );
}

export default Access;
